import * as Immutable from 'immutable';
import {
  GET_TEAMMEMBER_REQUESTED,
  GET_TEAMMEMBER_COMPLETED,
  GET_TEAMMEMBER_FAILED,
  RESET_TEAMMEMBER_REQUESTED,
  RESET_TEAMMEMBER_COMPLETED,
} from '../../actions/teammemberinfo/types';

const schema = {
  // status: 'INIT', // INIT/OK/ERROR
  error: null,
  data: { items: [] },
  resettingdata: false,
  gettingdata: false,
  gotdata: false,
};

const initialState = Immutable.Map(schema);

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TEAMMEMBER_REQUESTED:
      return state.set('error', null).set('gettingdata', true);

    case GET_TEAMMEMBER_COMPLETED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('data', action.payload);

    case GET_TEAMMEMBER_FAILED:
      return state.set('error', action.payload);

    case RESET_TEAMMEMBER_REQUESTED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('resettingdata', true)
        .set('gotdata', true);

    case RESET_TEAMMEMBER_COMPLETED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('resettingdata', false)
        .set('data', {})
        .set('gotdata', true);

    default:
      return state;
  }
};

export { initialState };

export default reducer;
